import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AccountSelectionAdapter {
  constructor(
    private occEndpoint: OccEndpointsService,
    private http: HttpClient,
  ) {}

  getCurrent(): Observable<any> {
    const endpoint = this.occEndpoint.buildUrl('current');
    return this.http.get(endpoint);
  }

  getAccountUsers(): Observable<any> {
    const endpoint = this.occEndpoint.buildUrl(`accountSelection`);

    return this.http.get(endpoint);
  }

  getAddressUsers(accountID: string): Observable<any> {
    const endpoint = this.occEndpoint.buildUrl(`addressSelection`, {
      urlParams: {
        accountID,
      },
    });

    return this.http.get(endpoint);
  }
}
